import React from 'react';

import Link from './Link';
import PreviewLink from './PreviewLink';
import { ENTITY_DISPLAY } from '../../constants/Urls';

const LinkSwitcher = ({ ...props }) => {
  const { isSavedSearchLink, to } = props;
  const showPreviewLink = to?.pathname === ENTITY_DISPLAY;

  return showPreviewLink && !isSavedSearchLink ? <PreviewLink {...props} /> : <Link {...props} />;
};

export default LinkSwitcher;
